<template>
	<div :class="['input', className, { search: search, currency: currency }]">
		<label :for="inputId" class="input__label">{{ label }}</label>
		<textarea
			v-if="isTextarea"
			:id="inputId"
			class="input__field input__field_textarea"
			:placeholder="placeholder"
			:rows="rows"
			:value="modelValue"
			:disabled="disabled"
			@input="$emit('update:modelValue', $event.target.value)"
		></textarea>
		<input
			v-else
			:id="inputId"
			:type="type"
			:disabled="disabled"
			class="input__field"
			:placeholder="placeholder"
			:value="modelValue"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
	</div>
</template>

<script>
export default {
	name: 'BaseInput',
	props: {
		modelValue: String,
		className: String,
		label: { type: String, default: '' },
		type: { type: String, default: 'text' },
		placeholder: { type: String, default: '' },
		isTextarea: { type: Boolean, default: false },
		search: { type: Boolean, default: false },
		currency: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
	},
	computed: {
		inputId() {
			if (this.label && this.label.trim() !== '') {
				return this.label.toLowerCase().replace(/\s+/g, '-');
			}
			return 'input-' + Math.random().toString(36).slice(2);
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.input {
	display: flex;
	flex-direction: column;
	gap: 5px;
	&.search {
		.input__field {
			padding-left: 50px;
		}
	}
	&.currency {
		.input__field {
			padding-right: 35px;
		}
	}
	&__label {
		display: inline-block;
		font-weight: 500;
		text-transform: capitalize;
		font-family: var(--font-family-inter);
		line-height: 120%;
		color: var(--primary-color);
	}
	&__field {
		width: 100%;
		height: 46px;
		border-radius: var(--border-radius-primary);
		background-color: rgba(196, 196, 196, 0.1);
		border: 1px solid var(--secondary-color);
		padding: 0px 15px;
		display: flex;
		align-items: center;
		color: var(--primary-color);
		outline: transparent;
		transition: border 0.3s ease 0s;
		font-size: var(--font-size-base);
		resize: none;
		transition: border 0.3s ease 0s;
		&:focus {
			border: 1px solid var(--primary-color);
		}
		&_textarea {
			overflow-y: auto;
			font-family: var(--font-family-inter);
			font-size: var(--font-size-base);
			line-height: var(--font-line-base);
			height: 150px;
			padding: 15px;
		}
	}
	input[type='number']::-webkit-outer-spin-button,
	input[type='number']::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type='number'] {
		-moz-appearance: textfield;
	}
}
</style>
